import { inject, injectable } from "tsyringe";
import { HttpClient } from "src/infra/http/client";

@injectable()
export class BenefitServingService {
    constructor(@inject("HttpClient") private http: HttpClient) {}
}
